/**
 * Created byJose Luis on 2017-08-15.
 * "Customer" service
 *
 * This consumes Customer REST Api
 *
 *
 */
import request from './request';
import { serializeParams } from '../common/helpers';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            //TODO Hay que hacer un buen manejo de errores. Por ahora simplemente regresamos test data pero se debe borrar y en caso de error en el webservice propagarlo a la vista de alguna forma para que se maneje posteriormente.
            return testData;
            //return error;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
            console.log("eee");
        });
};

export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const Delete = (url = '', params = {}) => {
    return request().delete(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};



// WEBPACK FOOTER //
// ./services/expensesTabularPriceses.js